/** Copyright (c) 2022-present TVM Engineering Authors. */
import { backgroundColor } from "./defaultStyles";

const sectionStyles = theme => ({
	root: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			paddingLeft: theme.spacing(3),
			paddingRight: theme.spacing(3),
		},
		paddingTop: 16,
		paddingBottom: 16,
		background: '#ffffff',
		justify: 'center'
	},
	bodyWrapper: {
		width: '96%',
		// marginLeft: "2%",
	},
	button: {
		marginTop: "25px",
		marginLeft: "25px",
		marginBottom: "5px",
	},
	actionHeader: {
		// margin: '15px',
		display: 'inline-flex'
	},
	contentHeader: {
		margin: '-40px 15px 30px',
		padding: '15px',
		fontFamily: '"Roboto", sans-serif',
		fontWeight: '300',
		lineHeight: '1.5em',
		borderRadius: '3px',
		background: backgroundColor, // ${theme.palette.primary}`,
		// background: `linear-gradient(60deg, ${theme.palette.primary.dark}, ${theme.palette.primary.light})`,
		boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
		color: '#fff'
	},
	title: {
		fontSize: '1.5rem',
		color: '#23282c',
		marginLeft: '0.8%'
	},
	description: {
		marginTop: 5,
		fontSize: 15,
		color: '#fff'
	}
});
export default sectionStyles;
